import { render, staticRenderFns } from "./manualInput.vue?vue&type=template&id=90b16f16&scoped=true&"
import script from "./manualInput.vue?vue&type=script&lang=js&"
export * from "./manualInput.vue?vue&type=script&lang=js&"
import style0 from "./manualInput.vue?vue&type=style&index=0&id=90b16f16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b16f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90b16f16')) {
      api.createRecord('90b16f16', component.options)
    } else {
      api.reload('90b16f16', component.options)
    }
    module.hot.accept("./manualInput.vue?vue&type=template&id=90b16f16&scoped=true&", function () {
      api.rerender('90b16f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/xiazeng/manualInput.vue"
export default component.exports